import { Box, Typography } from "@mui/material";
import { OptionsMostFrequent } from "../../../../../../../../service/questionarie/response";
import { useStyles } from "./styles";
import { icons } from "../../../../../../../../utils/icons";
import { FolioType } from "../../../../utils/enums/folioType";

interface PropsOptions {
  onClickCorrective?: (priorityId: number, areaId: number, areaName: string, departmentId: number, departmentName: string, subcategories: { id: number; name: string; categoryName: string; categoryId: number; }[], userAssigned?: number) => void,
  onClickPreventive?: (priorityId: number, areaId: number, areaName: string, departmentId: number, departmentName: string, subcategories: { id: number; name: string; categoryName: string; categoryId: number; }[], userAssigned?: number) => void,
  typeFolio: FolioType
  idSubOptionCorrective?: { areaId: number, departmentId: number, subcategories: { subcategoryId: number, subcategory: string, category: string }[], userAssigned?: number }
  idSubOptionPreventive?: { areaId: number, departmentId: number, subcategories: { subcategoryId: number, subcategory: string, category: string }[], userAssigned?: number }
}

interface GroupedCategory {
  categoryId: number;
  categoryName: string;
  subcategories: string;
}

export const CategoryFrecuents: React.FC<OptionsMostFrequent & PropsOptions> = ({ areaName, typeFolio, departmentName, category, subcategory, amountFolios, onClickCorrective, onClickPreventive, areaId, departmentId, subcategoryId, idSubOptionCorrective, idSubOptionPreventive, priorityId, userAssigned, categories, fullNameUserAssing }) => {

  const areSubcategoriesEqual = (
    subA: { subcategoryId: number, subcategory: string, category: string }[] = [],
    subB: { id: number; name: string; categoryName: string; }[] = []
  ) => {
    if (subA.length !== subB.length) return false;

    // Ordenamos los arreglos por `id` para garantizar el mismo orden antes de comparar
    const sortedA = [...subA].sort((a, b) => a.subcategoryId - b.subcategoryId);
    const sortedB = [...subB].sort((a, b) => a.id - b.id);

    return sortedA.every((sub, index) =>
      sub.subcategoryId === sortedB[index].id &&
      sub.subcategory === sortedB[index].name &&
      sub.category === sortedB[index].categoryName
    );
  };

  const subcategoriesFormatted = categories?.map(sub => ({
    id: sub.subcategoryId,
    name: sub.subcategory,
    categoryName: sub.category,
    categoryId: sub.categoryId
  }));

  const groupedByCategory = categories?.reduce<Record<number, GroupedCategory>>((acc, sub) => {
    const { category, categoryId, subcategory } = sub;

    if (!acc[categoryId]) {
      acc[categoryId] = {
        categoryId,
        categoryName: category,
        subcategories: subcategory
      };
    } else {
      acc[categoryId].subcategories += `, ${subcategory}`;
    }

    return acc;
  }, {});

  // Convertimos el objeto en un array
  const groupedArray: GroupedCategory[] = Object.values(groupedByCategory);


  const selected = typeFolio == FolioType.CORRECTIVE ?
    idSubOptionCorrective?.areaId == areaId && idSubOptionCorrective.userAssigned == userAssigned && idSubOptionCorrective.departmentId == departmentId && areSubcategoriesEqual(idSubOptionCorrective?.subcategories, subcategoriesFormatted)
    :
    idSubOptionPreventive?.areaId == areaId && idSubOptionPreventive.userAssigned == userAssigned && idSubOptionPreventive.departmentId == departmentId && areSubcategoriesEqual(idSubOptionPreventive?.subcategories, subcategoriesFormatted);

  const styles = useStyles()

  const handleSelect = () => {
    if (typeFolio == FolioType.CORRECTIVE && onClickCorrective) {
      onClickCorrective(priorityId, areaId, areaName, departmentId, departmentName, subcategoriesFormatted, userAssigned)
    } else if (typeFolio == FolioType.PREVENTIVE && onClickPreventive) {
      onClickPreventive(priorityId, areaId, areaName, departmentId, departmentName, subcategoriesFormatted, userAssigned)
    }

  };

  return (
    <Box
      sx={styles.container(selected)}
      onClick={handleSelect}
    >
      {/* Contenedor del icono y el título */}
      <Box sx={styles.secondContainer}>
        {/* Icono de la tuerca */}
        {/* <IconButton
          sx={{
            backgroundColor: selected ? "#ddd" : "transparent",
            '&:hover': {
              backgroundColor: "#bbb",
            },
            mr: 2,
          }}
        > */}
        {icons('setting')}
        {/*  </IconButton> */}
      </Box>

      {/* Lista de detalles */}
      <Box sx={styles.column}>
        <Typography variant="subtitle1" fontWeight="bold">
          {`${areaName} - ${departmentName}`}
        </Typography>
        {typeFolio == FolioType.CORRECTIVE ?
          <Typography variant="body2">
            <strong>{category}:</strong> {subcategory}
          </Typography>
          :
          <Box sx={{ maxHeight: '60px', overflow: 'auto', scrollbarWidth: 'none' }}>
            {groupedArray?.map((sub, index) => (
              <Typography variant="body2" key={sub.categoryId}>
                <strong>{sub.categoryName}:</strong> {sub.subcategories}
              </Typography>
            ))}
          </Box>
        }

        {/* <Typography variant="body2">
            <strong>{t("reportFolio.amountFolios")}:</strong> {amountFolios}
          </Typography> */}
      </Box>
    </Box>
  );
};
